import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NetworkGroupRoutes = defineRoute({
    record: {
        route: {
            path: "/network-group",
            component: () => loadView(import("./NetworkGroupTable.vue")),
        },
    },
    create: {
        route: {
            path: "/network-group/create",
            component: () => loadView(import("./NetworkGroupCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/network-group/update/:id",
            component: () => loadView(import("./NetworkGroupUpdate.vue")),
        },
        build(id: string) {
            return `/network-group/update/${id}`;
        },
    },
});
